export const UPDATED_SAFE_TRADE_STATUS = 'UPDATED_SAFE_TRADE_STATUS';



// WEBPACK FOOTER //
// ./safeTrade/seller/safeTradeActionTypes.js